<span class="spinner login-submit fa fa-spinner"></span>
<p class="info">{{{o.__("Hold tight, we're fetching the registration form…")}}}</p>
{[ if (o.cancel) { ]}
    <button class="btn btn-secondary button-cancel hor_centered">{{{o.__('Cancel')}}}</button>
{[ } ]}
